import React, { useCallback, useEffect, useState } from "react";
import StatisticTooltip from "./StatisticTooltip";
import { useSelector } from "react-redux";
import { selectBuilding } from "../../Main/main.slice";
import Loader from "components/Loader/Loader";
import { getBuildingFinancials, selectState, setSelectedDates } from "../financials.slice";
import { useAppDispatch } from "hooks/hooks";
import "../../../../Projects/styles/main.scss"
import ReceivablesAndPayables from "./ReceivablesAndPayables";
import FuelAndResources from "./FuelAndResources";
import Carnets from "./Carnets";
import Stock from "./Stock";
import ConcreteBaseOwnProducts from "./ConcreteBaseOwnProducts";
import { selectState as selectStateAuth } from "authentication/main.slice";
import DatePicker, { registerLocale } from "react-datepicker";
import { FormatDateIso, getLastDateOfMonth } from "utils/dateUtils";
import srLatn from "date-fns/locale/sr-Latn";
import ToolboxButton, { ToolboxButtonIcon } from "Dashboard/components/Buttons/ToolboxButton";
import { hasWriteAccessTo } from "utils/authUtil";
import { HIGH_RISE_SALES_MODULE_NAME } from "Dashboard/scenes/HighRiseSales/domain/HighRiseSalesModule";

registerLocale("sr-Latn", srLatn);

const BottomSection = () => {
  const dispatch = useAppDispatch();
  const {
    loading,
    generalFinancials,
    consumableExemptionFinancials,
    concreteBaseOwnProductsFinancials,
    selectedDateFrom,
    selectedDateTo
  } = useSelector(selectState);
  const { user } = useSelector(selectStateAuth);

  const [statisticActive, setStatisticActive] = useState(false);

  const buttonHandler = (event: React.MouseEvent<HTMLElement>) => {
    setStatisticActive(true);
  };

  const building = useSelector(selectBuilding);
  const { buildingId } = building?.building || {};

  const initialDateFrom: Date | null =
    selectedDateFrom ? new Date(selectedDateFrom) : null;
  const initialDateTo: Date | null =
    selectedDateTo ? new Date(selectedDateTo) : null;
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    initialDateFrom, initialDateTo
  ]);

  const selectDate = useCallback((update: [Date | null, Date | null]) => {
    setDateRange(update);
    const [dateFrom, dateTo] = update;
    let lastDayForDateTo = dateTo != null
      ? getLastDateOfMonth(dateTo) : null;
    dispatch(setSelectedDates({
      dateFrom: dateFrom ? FormatDateIso(dateFrom) : undefined,
      dateTo: lastDayForDateTo ? FormatDateIso(lastDayForDateTo) : undefined
    }))
  }, [dispatch]);

  useEffect(() => {
    if (buildingId) {
      dispatch(getBuildingFinancials({
        buildingId,
        from: selectedDateFrom,
        to: selectedDateTo
      }));
    }
  }, [dispatch, buildingId, selectedDateFrom, selectedDateTo]);

  return (
    <section className="loading-container">
      {loading && <Loader />}
      <h1 className="h1-absolute">
        <ToolboxButton
          icon={ToolboxButtonIcon.Chart}
          tooltip="Info"
          onClick={hasWriteAccessTo(user, HIGH_RISE_SALES_MODULE_NAME)
            ? buttonHandler : undefined}
        />
        {building?.building.fullName}
        <StatisticTooltip
          general={generalFinancials?.general}
          receivables={generalFinancials?.accountReceivableFinancials}
          payables={generalFinancials?.accountPayableFinancials}
          building={building?.building}
          active={statisticActive}
          setActive={setStatisticActive}
        />
      </h1>
      <div className="buildings-bottom-content">
        <ReceivablesAndPayables
          receivables={generalFinancials?.accountReceivableFinancials}
          payables={generalFinancials?.accountPayableFinancials}
        />
        <FuelAndResources
          buildingId={buildingId}
          data={consumableExemptionFinancials}
        />
        <Carnets data={generalFinancials?.carnets} />
        <Stock data={generalFinancials?.stockOutputFinancials} />
        <ConcreteBaseOwnProducts
          buildingId={buildingId}
          data={concreteBaseOwnProductsFinancials}
        />
        <div className="daily-report-box">
          <div className="monthRange">
            <h3 className="monthRangeTitle"><strong>Prikaz finansija za:</strong></h3>
            <DatePicker
              selectsRange={true}
              startDate={dateRange[0]}
              endDate={dateRange[1]}
              onChange={selectDate}
              dateFormat="MMMM yyyy"
              showMonthYearPicker
              isClearable={true}
              locale="sr-Latn"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomSection;
